<div class="d-flex flex-column gap-4">
  <div class="title-md" i18n>Effective Period</div>
  <div class="general-details-form-grid" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label [for]="'startDate'" class="form-input-label" i18n>Effective Start Date</label>
      <app-datepicker-input
        formControlName="startDate"
        controlId="startDate"
        [error]="formSubmitted && formGroup.controls.startDate.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.startDate.invalid"
        [customErrorMessages]="customErrorMessages.startDate"
        [errors]="formGroup.controls.startDate.errors" />
    </div>
    <div class="d-flex flex-column gap-1">
      <label [for]="'endDate'" class="form-input-label" i18n>Expiry Date</label>
      <app-datepicker-input
        formControlName="endDate"
        controlId="endDate"
        [error]="formSubmitted && formGroup.controls.endDate.invalid" />
      <div class="form-input-hint" i18n>Optional</div>
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.endDate.invalid"
        [customErrorMessages]="customErrorMessages.endDate"
        [errors]="formGroup.controls.endDate.errors" />
    </div>
  </div>
</div>
